import {
 Alert,
 Box,
 Dialog,
 DialogContent,
 DialogTitle,
 IconButton,
 Snackbar,
 Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { FiArrowDown, FiArrowUp, FiX } from "react-icons/fi";

export function Notice({ status, onClose }) {
 const open = Boolean(status?.text && status.type !== "idle");
 const severity =
  status.type === "error"
   ? "error"
   : status.type === "success"
     ? "success"
     : "info";

 return (
  <Snackbar
   anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
   autoHideDuration={2000}
   open={open}
   onClose={onClose}
  >
   <Alert className="notice-alert" severity={severity} variant="filled" onClose={onClose}>
    {status.text}
   </Alert>
  </Snackbar>
 );
}

export function AdminDialog({ open, title, eyebrow, onClose, children, maxWidth = "md" }) {
 return (
  <Dialog className="admin-dialog" fullWidth maxWidth={maxWidth} open={open} onClose={onClose}>
   <DialogTitle className="admin-dialog-title">
    <Box>
     {eyebrow ? <span>{eyebrow}</span> : null}
     <strong>{title}</strong>
    </Box>
    <IconButton aria-label="Close modal" onClick={onClose}>
     <FiX />
    </IconButton>
   </DialogTitle>
   <DialogContent dividers>{children}</DialogContent>
  </Dialog>
 );
}

export function GridShell({
 rows,
 columns,
 getRowId,
 emptyText = "No records found.",
 rowHeight = 74,
 rowCount,
 paginationMode,
 paginationModel,
 onPaginationModelChange,
}) {
 return (
  <Box className="mui-grid-shell">
   <DataGrid
    rows={rows}
    columns={columns}
    getRowId={getRowId}
    disableColumnMenu
    disableRowSelectionOnClick
    rowHeight={rowHeight}
    pageSizeOptions={[100]}
    initialState={{ pagination: { paginationModel: { page: 0, pageSize: 100 } } }}
    rowCount={rowCount}
    paginationMode={paginationMode}
    paginationModel={paginationModel}
    onPaginationModelChange={onPaginationModelChange}
    localeText={{ noRowsLabel: emptyText }}
   />
  </Box>
 );
}

export function IconAction({ label, icon: Icon, onClick, tone = "default" }) {
 return (
  <Tooltip title={label}>
   <IconButton
    className={`grid-icon-action ${tone}`}
    aria-label={label}
    onClick={onClick}
    size="small"
   >
    <Icon />
   </IconButton>
  </Tooltip>
 );
}

export function Stat({ icon: Icon, label, value, tone, change = "0%", negative = false, onClick }) {
 const TrendIcon = negative ? FiArrowDown : FiArrowUp;

 return (
  <button className="stat" style={{ "--tone": tone }} type="button" onClick={onClick}>
   <div>
    <p>{label}</p>
    <strong>{value}</strong>
    <small className={negative ? "negative" : "positive"}>
     <span>
      <TrendIcon /> {change}
     </span>
     <em>vs last month</em>
    </small>
   </div>
   <span>
    <Icon />
   </span>
  </button>
 );
}
